module.exports = "<div id=\"pmViewHolder\">\r\n\r\n  <app-pm-template2></app-pm-template2>\r\n  \r\n</div>  \r\n\r\n"